import './style/index.js';

import _Tabs from './Tabs';

export type { TabPanelProps } from './TabPanel';
export type { TabsProps } from './Tabs';
export * from './type';

export const Tabs = _Tabs;
export default Tabs;
